import { render } from "./Title.vue?vue&type=template&id=7924f808&scoped=true"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"

import "./Title.vue?vue&type=style&index=0&id=7924f808&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dymek\\Desktop\\Projects\\Lusterka Adam\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7924f808"]])

export default __exports__